// Updated MainLayout.js - Fixed to respect scheduled unlock times and Session 0 quiz requirement
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { fetchSessionStatusFast, initializeUserSessions, supabase } from "../../supabase";

// Mobile Bottom Navigation Component
const MobileBottomNav = ({ user, userProfile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useAuth();

  const navItems = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: 'home',
      path: '/dashboard',
      color: '#1B365D'
    },
    {
      id: 'sessions',
      label: 'Sessions',
      icon: 'video',
      path: '/sessions',
      color: '#6B7280'
    },
    {
      id: 'practice-log',
      label: 'Practice Log',
      icon: 'calendar',
      path: '/practice',
      color: '#6B7280'
    },
    {
      id: 'guided-practice',
      label: 'Daily Guided',
      icon: 'play',
      path: '/guided-practices',
      color: '#6B7280'
    },
    {
      id: 'logout',
      label: 'Logout',
      icon: 'logout',
      path: '/logout',
      color: '#6B7280'
    }
  ];

  const isActive = (path) => {
    if (path === '/sessions') {
      return location.pathname === '/sessions' || location.pathname.startsWith('/session');
    }
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname === '/';
    }
    if (path === '/practice') {
      return location.pathname === '/practice';
    }
    if (path === '/guided-practices') {
      return location.pathname === '/guided-practices';
    }
    return location.pathname === path;
  };

  const handleNavigation = async (item) => {
    if (item.id === 'logout') {
      await signOut();
      navigate('/login');
    } else {
      navigate(item.path);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#FFFFFF',
      borderTop: '1px solid #E5E7EB',
      padding: '8px 8px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 1000,
      boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)'
    }}>
      {navItems.map((item) => {
        const active = isActive(item.path);
        
        return (
          <div key={item.id} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2px',
            cursor: 'pointer',
            padding: '6px 4px',
            borderRadius: '14px',
            backgroundColor: active ? '#EFF6FF' : 'transparent',
            border: active ? '1px solid #3B82F6' : '1px solid transparent',
            minWidth: '48px',
            flex: 1,
            maxWidth: '68px'
          }}
          onClick={() => handleNavigation(item)}>
            {item.icon === 'home' && (
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={active ? '#1B365D' : '#6B7280'}>
                <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/>
              </svg>
            )}
            {item.icon === 'video' && (
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={active ? '#1B365D' : '#6B7280'}>
                <path d="M300-80q-58 0-99-41t-41-99v-520q0-58 41-99t99-41h500v600q-25 0-42.5 17.5T740-220q0 25 17.5 42.5T800-160v80H300Zm-60-267q14-7 29-10t31-3h20v-440h-20q-25 0-42.5 17.5T240-740v393Zm160-13h320v-440H400v440Zm-160 13v-453 453Zm60 187h373q-6-14-9.5-28.5T660-220q0-16 3-31t10-29H300q-26 0-43 17.5T240-220q0 26 17 43t43 17Z"/>
              </svg>
            )}
            {item.icon === 'calendar' && (
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={active ? '#1B365D' : '#6B7280'}>
                <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z"/>
              </svg>
            )}
            {item.icon === 'play' && (
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={active ? '#1B365D' : '#6B7280'}>
                <path d="m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
              </svg>
            )}
            {item.icon === 'logout' && (
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={active ? '#1B365D' : '#6B7280'}>
                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/>
              </svg>
            )}
            <span style={{
              fontSize: '10px',
              color: active ? '#1B365D' : '#6B7280',
              fontWeight: '500',
              textAlign: 'center',
              lineHeight: '1.2'
            }}>
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

const DashboardNav = ({ 
  currentPath = '/dashboard',
  onNavigate = (path) => console.log('Navigate to:', path),
  sessions = []
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openSessions, setOpenSessions] = useState(false);
  const [openHomePractice, setOpenHomePractice] = useState(false);
  const [localSessions, setLocalSessions] = useState([]);
  const [sessionsLoading, setSessionsLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const { user, userProfile, signOut } = useAuth();

  // Simple fallback sessions - always include session 0 
  const defaultSessions = [
    { id: "session0", number: 0, title: "Introduction", unlocked: true, completed: false },
    { id: "session1", number: 1, title: "Session 1", unlocked: false, completed: false },
    { id: "session2", number: 2, title: "Session 2", unlocked: false, completed: false },
    { id: "session3", number: 3, title: "Session 3", unlocked: false, completed: false },
    { id: "session4", number: 4, title: "Session 4", unlocked: false, completed: false },
    { id: "session5", number: 5, title: "Session 5", unlocked: false, completed: false }
  ];

  // Home Practice subsections
  const homePracticeSubsections = [
    {
      id: 'practice-log',
      label: 'Practice Log',
      path: '/practice',
      icon: 'calendar',
      description: 'Track sessions & progress',
    },
    {
      id: 'guided-videos',
      label: 'Daily Guided Practice',
      path: '/guided-practices',
      icon: 'video-practice',
      description: 'Daily practice videos',
    },
  ];

  // FIXED: Updated fetchSessionData function to match dashboard logic
  const fetchSessionData = useCallback(async () => {
    if (!user?.id || sessionsLoading || hasFetched) return;

    try {
      setSessionsLoading(true);
      console.log("🔄 MainLayout: Fetching session data for user:", user.id);
      
      // Initialize user sessions first (includes session 0)
      await initializeUserSessions(user.id);
      
      // Fetch sessions with detailed progress data
      const { data: sessionsData, error } = await supabase
        .from('user_sessions')
        .select(
          `
          session_number,
          session_completed,
          session_fully_completed,
          session_started,
          video_watched,
          video_completed,
          quiz_completed,
          pain_level,
          pain_level_timestamp,
          goals_set_timestamp,
          weekly_goals,
          next_session_unlock_time,
          quiz_score,
          video_progress_percentage,
          created_at,
          pre_assessment_completed
        `,
        )
        .eq('user_id', user.id)
        .order('session_number');

      if (error) {
        console.error('❌ MainLayout: Error fetching sessions:', error);
        setLocalSessions(defaultSessions);
        setHasFetched(true);
        return;
      }

      // Fetch user's session schedule
      const { data: schedule } = await supabase
        .from('participant_session_schedule')
        .select('*')
        .eq('user_id', user.id)
        .single();

      console.log('📅 MainLayout: User session schedule:', schedule);

      // Fetch manual overrides
      const { data: manualOverrides } = await supabase
        .from('manual_session_overrides')
        .select('*')
        .eq('user_id', user.id);

      console.log('🔓 MainLayout: Manual session overrides:', manualOverrides);

      // Session metadata - includes session 0
      const sessionMetadata = [
        { id: "session0", number: 0, title: "Introduction" },
        { id: "session1", number: 1, title: "Session 1" },
        { id: "session2", number: 2, title: "Session 2" },
        { id: "session3", number: 3, title: "Session 3" },
        { id: "session4", number: 4, title: "Session 4" },
        { id: "session5", number: 5, title: "Session 5" }
      ];
      
      // Transform sessions with proper unlock logic
      const transformedSessions = sessionMetadata.map(metadata => {
        const sessionData = sessionsData?.find(s => s.session_number === metadata.number);
        
        // Check for manual override
        const override = manualOverrides?.find(o => o.session_number === metadata.number);
        
        // Determine if session is unlocked
        let isUnlocked = metadata.number === 0; // Session 0 is always unlocked
        let scheduledUnlockTime = null;
        
        // PRIORITY 1: Check manual override
        if (override) {
          isUnlocked = override.override_status === 'unlocked';
          console.log(
            `🔐 MainLayout Session ${metadata.number} has manual override: ${override.override_status}`,
          );
        } else if (metadata.number === 1) {
          // Session 1 unlocks after Session 0 completion (video + quiz)
          const sessionZero = sessionsData?.find((s) => s.session_number === 0);
          if (sessionZero) {
            // BACKWARDS COMPATIBILITY: If intro was completed before quiz was added
            const videoCompleted =
              sessionZero.video_completed || sessionZero.video_watched;
            const quizCompleted = sessionZero.quiz_completed;

            // Session is complete if:
            // 1. session_completed flag is true (legacy), OR
            // 2. Both video AND quiz are completed (new requirement)
            const isIntroComplete =
              sessionZero.session_completed ||
              (videoCompleted && quizCompleted);

            isUnlocked = isIntroComplete;

            console.log(`🔍 MainLayout Session 1 unlock check:`, {
              videoCompleted,
              quizCompleted,
              sessionCompleted: sessionZero.session_completed,
              unlocked: isUnlocked,
            });
          }
        } else if (metadata.number > 1) {
          // PRIORITY: Check if session is marked complete first - if so, always unlock (Mark Complete = force unlock)
          const isSessionComplete =
            sessionData?.session_completed ||
            sessionData?.session_fully_completed;
          if (isSessionComplete) {
            isUnlocked = true;
            console.log(
              `✅ MainLayout Session ${metadata.number} is marked complete - forcing unlock`,
            );
          } else {
            // Sessions 2+ require scheduled unlock time
            if (schedule) {
              const scheduledUnlockTimeStr =
                schedule[`session_${metadata.number}_unlock_time`];

              if (scheduledUnlockTimeStr) {
                const now = new Date();
                const unlockTime = new Date(scheduledUnlockTimeStr);
                isUnlocked = now >= unlockTime;
                scheduledUnlockTime = unlockTime;

                console.log(
                  `📅 MainLayout Session ${metadata.number} scheduled check:`,
                  {
                    scheduledTime: unlockTime,
                    currentTime: now,
                    isUnlocked,
                  },
                );
              } else {
                isUnlocked = false;
                console.log(
                  `🔒 MainLayout Session ${metadata.number} has NO schedule - keeping LOCKED`,
                );
              }
            } else {
              isUnlocked = false;
              console.log(
                `🔒 MainLayout Session ${metadata.number} - NO schedule found - keeping LOCKED`,
              );
            }
          }
        }
        
        // Determine completion status with backwards compatibility
        let completed = false;
        
        if (metadata.number === 0) {
          // Introduction is complete when BOTH video AND quiz are done
          // BUT: Backwards compatibility - if session_completed flag exists, honor it
          completed = sessionData?.session_completed || 
                      sessionData?.session_fully_completed || 
                      ((sessionData?.video_watched || sessionData?.video_completed) && sessionData?.quiz_completed);
        } else {
          // Other sessions use existing logic
          completed = sessionData?.session_completed || sessionData?.session_fully_completed || false;
        }
        
        return {
          ...metadata,
          completed: completed,
          unlocked: isUnlocked,
          sessionStarted: sessionData?.session_started || false,
          videoWatched: sessionData?.video_watched || false,
          quizCompleted: sessionData?.quiz_completed || false,
          scheduledUnlockTime: scheduledUnlockTime
        };
      });
      
      console.log("✅ MainLayout: Sessions loaded with scheduled unlock logic:", transformedSessions);
      setLocalSessions(transformedSessions);
      setHasFetched(true);
      
    } catch (error) {
      console.error("❌ MainLayout: Error fetching session data:", error);
      setLocalSessions(defaultSessions);
      setHasFetched(true);
    } finally {
      setSessionsLoading(false);
    }
  }, [user?.id, sessionsLoading, hasFetched]);

  // Use provided sessions, fetched sessions, or default sessions
  const sessionsToUse = sessions.length > 0 ? sessions : 
                       localSessions.length > 0 ? localSessions : 
                       defaultSessions;

  // Fetch sessions when component mounts, but only once
  useEffect(() => {
    if (user?.id && sessions.length === 0 && !hasFetched) {
      console.log("🔄 MainLayout: Triggering session fetch");
      const timeoutId = setTimeout(() => {
        fetchSessionData();
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [user?.id, sessions.length, hasFetched, fetchSessionData]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggleSessions = () => setOpenSessions(!openSessions);
  const handleToggleHomePractice = () => setOpenHomePractice(!openHomePractice);
  const handleSessionClick = (sessionPath) => {
    console.log('Navigating to session:', sessionPath);
    onNavigate(sessionPath);
    setOpenSessions(false);
  };
  
  const handleLogout = async () => {
    await signOut();
    onNavigate("/login");
  };

  // Check if current path matches
  const isActive = (path) => {
    if (path === '/dashboard') {
      return currentPath === '/dashboard' || currentPath === '/';
    }
    if (path === '/home-practice') {
      return currentPath === '/practice' || currentPath === '/guided-practices';
    }
    return currentPath === path;
  };
  
  const isSessionActive = () => currentPath.startsWith('/session');
  const isHomePracticeActive = () => currentPath === '/practice' || currentPath === '/guided-practices';

  // Don't render desktop nav on mobile
  if (isMobile) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '280px',
        backgroundColor: '#FFFFFF',
        borderRight: '1px solid #E5E7EB',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '2px 0 4px rgba(0, 0, 0, 0.05)',
      }}
    >
      {/* Header Section with Logo */}
      <div
        style={{
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '16px',
          margin: '32px 20px 24px 20px',
          height: '120px',
          boxSizing: 'border-box',
        }}
      >
        <img
          src="/assets/FFWLOGO.png"
          alt="Face Forward Web Logo"
          style={{
            width: '100%',
            height: '80px',
            objectFit: 'contain',
            filter:
              'brightness(0) saturate(100%) invert(11%) sepia(66%) saturate(1347%) hue-rotate(202deg) brightness(93%) contrast(107%)',
          }}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <svg
          width="60"
          height="40"
          fill="#1B365D"
          viewBox="0 0 24 24"
          style={{ display: 'none' }}
        >
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      </div>

      {/* Scrollable Navigation Content */}
      <div
        style={{
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ padding: '0 24px', flex: 1 }}>
          {/* Dashboard */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              backgroundColor: isActive('/dashboard')
                ? '#EFF6FF'
                : 'transparent',
              borderRadius: '20px',
              marginBottom: '8px',
              cursor: 'pointer',
              border: isActive('/dashboard')
                ? '1px solid #3B82F6'
                : '1px solid transparent',
              transition: 'all 0.2s ease',
            }}
            onClick={() => onNavigate('/dashboard')}
            onMouseEnter={(e) => {
              if (!isActive('/dashboard')) {
                e.currentTarget.style.backgroundColor = '#F3F4F6';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#1B365D';
                if (svg) svg.setAttribute('fill', '#1B365D');
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/dashboard')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#374151';
                if (svg) svg.setAttribute('fill', '#374151');
              }
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill={isActive('/dashboard') ? '#1B365D' : '#374151'}
              >
                <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" />
              </svg>
            </div>
            <span
              style={{
                color: isActive('/dashboard') ? '#1B365D' : '#374151',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Dashboard
            </span>
          </div>

          {/* Sessions with Dropdown */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              borderRadius: '20px',
              marginBottom: '8px',
              cursor: 'pointer',
              color: isSessionActive() ? '#1B365D' : '#374151',
              backgroundColor: isSessionActive() ? '#EFF6FF' : 'transparent',
              border: isSessionActive()
                ? '1px solid #3B82F6'
                : '1px solid transparent',
              transition: 'all 0.2s ease',
            }}
            onClick={handleToggleSessions}
            onMouseEnter={(e) => {
              if (!isSessionActive()) {
                e.currentTarget.style.backgroundColor = '#F3F4F6';
                e.currentTarget.style.color = '#1B365D';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#1B365D';
                if (svg) svg.setAttribute('fill', '#1B365D');
              }
            }}
            onMouseLeave={(e) => {
              if (!isSessionActive()) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#374151';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#374151';
                if (svg) svg.setAttribute('fill', '#374151');
              }
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill="currentColor"
              >
                <path d="M300-80q-58 0-99-41t-41-99v-520q0-58 41-99t99-41h500v600q-25 0-42.5 17.5T740-220q0 25 17.5 42.5T800-160v80H300Zm-60-267q14-7 29-10t31-3h20v-440h-20q-25 0-42.5 17.5T240-740v393Zm160-13h320v-440H400v440Zm-160 13v-453 453Zm60 187h373q-6-14-9.5-28.5T660-220q0-16 3-31t10-29H300q-26 0-43 17.5T240-220q0 26 17 43t43 17Z" />
              </svg>
            </div>
            <span
              style={{
                fontSize: '14px',
                fontWeight: '500',
                color: isSessionActive() ? '#1B365D' : '#374151',
                flex: 1,
              }}
            >
              Sessions
            </span>
            {sessionsLoading ? (
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  border: '2px solid #f1f3f4',
                  borderTop: '2px solid #1B365D',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
            ) : (
              <svg
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 24 24"
                style={{
                  transform: openSessions ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                }}
              >
                <path d="M7 10l5 5 5-5z" />
              </svg>
            )}
          </div>

          {/* Session Dropdown */}
          {openSessions && (
            <div
              style={{
                marginBottom: '12px',
                backgroundColor: '#F8F9FA',
                borderRadius: '20px',
                padding: '8px',
                margin: '0 24px 12px 24px',
                border: '1px solid #E5E7EB',
              }}
            >
              {sessionsLoading ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    color: '#374151',
                  }}
                >
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #f1f3f4',
                      borderTop: '2px solid #1B365D',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginRight: '8px',
                    }}
                  />
                  Loading sessions...
                </div>
              ) : sessionsToUse.length === 0 ? (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    color: '#374151',
                    fontSize: '13px',
                  }}
                >
                  No sessions available
                </div>
              ) : (
                sessionsToUse.map((session, index) => {
                  const sessionPath =
                    session.number === 0
                      ? '/session00'
                      : `/session${(session.number || session.id?.replace('session', '') || '1').toString().padStart(2, '0')}`;
                  const isSessionItemActive = currentPath === sessionPath;
                  const sessionUnlocked =
                    session.unlocked !== undefined ? session.unlocked : false;
                  const sessionCompleted = session.completed || false;

                  return (
                    <div
                      key={session.id || session.number || index}
                      onClick={() =>
                        sessionUnlocked && handleSessionClick(sessionPath)
                      }
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '10px 12px',
                        borderRadius: '16px',
                        marginBottom:
                          index === sessionsToUse.length - 1 ? '0' : '4px',
                        backgroundColor: isSessionItemActive
                          ? '#EFF6FF'
                          : '#FFFFFF',
                        border: isSessionItemActive
                          ? '1px solid #3B82F6'
                          : '1px solid #E5E7EB',
                        cursor: sessionUnlocked ? 'pointer' : 'not-allowed',
                        transition: 'all 0.2s ease',
                        opacity: sessionUnlocked ? 1 : 0.5,
                      }}
                      onMouseEnter={(e) => {
                        if (!isSessionItemActive && sessionUnlocked) {
                          e.currentTarget.style.backgroundColor = '#F3F4F6';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSessionItemActive && sessionUnlocked) {
                          e.currentTarget.style.backgroundColor = '#FFFFFF';
                        }
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                        }}
                      >
                        <div
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            backgroundColor: sessionCompleted
                              ? '#ECFDF5'
                              : sessionUnlocked
                                ? '#EFF6FF'
                                : '#F9FAFB',
                            color: sessionCompleted
                              ? '#10B981'
                              : sessionUnlocked
                                ? '#1B365D'
                                : '#9CA3AF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '11px',
                            fontWeight: '600',
                            border: sessionCompleted
                              ? '1px solid #10B981'
                              : sessionUnlocked
                                ? '1px solid #3B82F6'
                                : '1px solid #E5E7EB',
                          }}
                        >
                          {session.number === 0 ? (
                            <svg
                              width="14"
                              height="14"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                            </svg>
                          ) : (
                            session.number ||
                            session.id?.replace('session', '') ||
                            index + 1
                          )}
                        </div>

                        <span
                          style={{
                            fontSize: '13px',
                            fontWeight: '500',
                            color: sessionUnlocked
                              ? isSessionItemActive
                                ? '#1B365D'
                                : '#374151'
                              : '#9CA3AF',
                          }}
                        >
                          {session.number === 0
                            ? 'Introduction'
                            : `Session ${session.number || session.id?.replace('session', '') || index + 1}`}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                        }}
                      >
                        {sessionCompleted && (
                          <div
                            style={{
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: '#ECFDF5',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <svg
                              width="8"
                              height="8"
                              fill="#10B981"
                              viewBox="0 0 24 24"
                            >
                              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                            </svg>
                          </div>
                        )}
                        {!sessionUnlocked && (
                          <div
                            style={{
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: '#F3F4F6',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <svg
                              width="8"
                              height="8"
                              fill="#9CA3AF"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}

          {/* Home Practice Section with Dropdown */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              borderRadius: '20px',
              marginBottom: '8px',
              cursor: 'pointer',
              color: isHomePracticeActive() ? '#1B365D' : '#374151',
              backgroundColor: isHomePracticeActive()
                ? '#EFF6FF'
                : 'transparent',
              border: isHomePracticeActive()
                ? '1px solid #3B82F6'
                : '1px solid transparent',
              transition: 'all 0.2s ease',
            }}
            onClick={handleToggleHomePractice}
            onMouseEnter={(e) => {
              if (!isHomePracticeActive()) {
                e.currentTarget.style.backgroundColor = '#F3F4F6';
                e.currentTarget.style.color = '#1B365D';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#1B365D';
                if (svg) svg.setAttribute('fill', '#1B365D');
              }
            }}
            onMouseLeave={(e) => {
              if (!isHomePracticeActive()) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#374151';
                const span = e.currentTarget.querySelector('span');
                const svg = e.currentTarget.querySelector('svg');
                if (span) span.style.color = '#374151';
                if (svg) svg.setAttribute('fill', '#374151');
              }
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill="currentColor"
              >
                <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
              </svg>
            </div>
            <span
              style={{
                fontSize: '14px',
                fontWeight: '500',
                color: isHomePracticeActive() ? '#1B365D' : '#374151',
                flex: 1,
              }}
            >
              Home Practice
            </span>
            <svg
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 24 24"
              style={{
                transform: openHomePractice ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }}
            >
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </div>

          {/* Home Practice Dropdown */}
          {openHomePractice && (
            <div
              style={{
                marginBottom: '12px',
                backgroundColor: '#F8F9FA',
                borderRadius: '20px',
                padding: '8px',
                margin: '0 24px 12px 24px',
                border: '1px solid #E5E7EB',
              }}
            >
              {homePracticeSubsections.map((subsection, index) => {
                const isSubsectionActive = currentPath === subsection.path;

                return (
                  <div
                    key={subsection.id}
                    onClick={() => {
                      onNavigate(subsection.path);
                      setOpenHomePractice(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '12px 12px',
                      borderRadius: '16px',
                      marginBottom:
                        index === homePracticeSubsections.length - 1
                          ? '0'
                          : '4px',
                      backgroundColor: isSubsectionActive
                        ? '#EFF6FF'
                        : '#FFFFFF',
                      border: isSubsectionActive
                        ? '1px solid #3B82F6'
                        : '1px solid #E5E7EB',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      if (!isSubsectionActive) {
                        e.currentTarget.style.backgroundColor = '#F3F4F6';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSubsectionActive) {
                        e.currentTarget.style.backgroundColor = '#FFFFFF';
                      }
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '8px',
                          backgroundColor: isSubsectionActive
                            ? '#1B365D'
                            : '#F8F9FA',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #E5E7EB',
                        }}
                      >
                        {subsection.icon === 'calendar' && (
                          <svg
                            width="12"
                            height="12"
                            fill={isSubsectionActive ? '#FFFFFF' : '#374151'}
                            viewBox="0 0 24 24"
                          >
                            <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                          </svg>
                        )}
                        {subsection.icon === 'video-practice' && (
                          <svg
                            width="12"
                            height="12"
                            fill={isSubsectionActive ? '#FFFFFF' : '#374151'}
                            viewBox="0 0 24 24"
                          >
                            <path d="m10 16.5 6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                          </svg>
                        )}
                        {subsection.icon === 'contact' && (
                          <svg
                            width="12"
                            height="12"
                            fill={isSubsectionActive ? '#FFFFFF' : '#374151'}
                            viewBox="0 0 24 24"
                          >
                            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                          </svg>
                        )}
                      </div>

                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            color: isSubsectionActive ? '#1B365D' : '#374151',
                          }}
                        >
                          {subsection.label}
                        </div>
                      </div>
                    </div>

                    {isSubsectionActive && (
                      <div
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: '#1B365D',
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
          {/* Contact Us */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              backgroundColor: isActive('/contact') ? '#EFF6FF' : 'transparent',
              borderRadius: '20px',
              marginBottom: '8px',
              cursor: 'pointer',
              border: isActive('/contact')
                ? '1px solid #3B82F6'
                : '1px solid transparent',
              transition: 'all 0.2s ease',
            }}
            onClick={() => onNavigate('/contact')}
            onMouseEnter={(e) => {
              if (!isActive('/contact')) {
                e.currentTarget.style.backgroundColor = '#F3F4F6';
                const span = e.currentTarget.querySelector('span');
                if (span) span.style.color = '#1B365D';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/contact')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                const span = e.currentTarget.querySelector('span');
                if (span) span.style.color = '#374151';
              }
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                width="16"
                height="16"
                fill={isActive('/contact') ? '#1B365D' : '#374151'}
                viewBox="0 0 24 24"
              >
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
            </div>
            <span
              style={{
                color: isActive('/contact') ? '#1B365D' : '#374151',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Contact Us
            </span>
          </div>
        </div>

        {/* Logout Button at Bottom */}
        <div
          style={{
            padding: '24px',
            borderTop: '1px solid #F3F4F6',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              backgroundColor: 'transparent',
              borderRadius: '20px',
              cursor: 'pointer',
              border: '1px solid #E5E7EB',
              transition: 'all 0.2s ease',
            }}
            onClick={handleLogout}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#1B365D';
              const span = e.currentTarget.querySelector('span');
              const svg = e.currentTarget.querySelector('svg');
              if (span) span.style.color = '#FFFFFF';
              if (svg) svg.setAttribute('fill', '#FFFFFF');
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              const span = e.currentTarget.querySelector('span');
              const svg = e.currentTarget.querySelector('svg');
              if (span) span.style.color = '#374151';
              if (svg) svg.setAttribute('fill', '#374151');
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill="#374151"
              >
                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" />
              </svg>
            </div>
            <span
              style={{
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
              }}
            >
              Logout
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const MainLayout = ({ children, currentSessions = [], currentPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut, user, userProfile } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Use passed currentPath or fallback to location.pathname
  const activePath = currentPath || location.pathname;

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigation = (path) => {
    console.log('MainLayout handling navigation to:', path);
    if (path === "/") {
      signOut();
      navigate("/login");
    } else {
      navigate(path);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      {/* Desktop Navigation */}
      {!isMobile && (
        <DashboardNav 
          currentPath={activePath} 
          onNavigate={handleNavigation}
          sessions={currentSessions}
        />
      )}
      
      {/* Main Content */}
      <div style={{ 
        flex: 1, 
        minHeight: '100vh',
        backgroundColor: '#F8F9FA',
        paddingBottom: isMobile ? '80px' : '0',
        marginLeft: isMobile ? '0' : '280px'
      }}>
        {children}
      </div>
      
      {/* Mobile Bottom Navigation */}
      {isMobile && <MobileBottomNav user={user} userProfile={userProfile} />}
      
      {/* Add CSS for spinner animation */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `
      }} />
    </div>
  );
};

export default MainLayout;